import { useEntitlements } from '~/hooks/use-entitlements';

/**
 * Stripe statuses that mean the customer currently holds a plan.
 *
 * One definition, imported by everything that asks the question. The Billing tab's visibility and
 * the panel behind it have to agree: a tab that appears for a customer the panel then tells to go
 * and pick a plan is worse than either answer on its own.
 */
export const ACTIVE_STATUSES = new Set(['active', 'trialing', 'past_due', 'unpaid']);

/**
 * Whether the customer holds a plan right now.
 *
 * `false` while the read is in flight and `false` when it fails - the caller is deciding whether to
 * SHOW something, and a thing that appears once a request lands is better than one that appears and
 * is taken away. `billingDetailUnavailable` is deliberately true: the perks are real even though the
 * billing detail behind them could not be read, and that state is one the customer most needs a
 * surface for.
 */
export function useHasSubscription(): boolean {
  const { subscription, status, billingDetailUnavailable } = useEntitlements();

  if (status !== 'ready') {
    return false;
  }
  if (billingDetailUnavailable) {
    return true;
  }
  return !!subscription && ACTIVE_STATUSES.has(subscription.status);
}
